import { useMutation } from '@tanstack/react-query';
import type { AgentApiSharedJobPostsImport } from '@/types/serializers';

/** 求人DBの求人を自社求人として取り込む */
export default function useImportSharedJobPosts() {
  return useMutation({
    mutationFn: async ({
      sharedJobPostIds,
    }: {
      sharedJobPostIds: number[];
    }): Promise<AgentApiSharedJobPostsImport> => {
      const response = await fetch('/agent/api/shared_job_posts/import', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token':
            document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '',
        },
        body: JSON.stringify({ shared_job_post_ids: sharedJobPostIds }),
      });

      if (!response.ok) {
        throw new Error('求人の取り込みに失敗しました');
      }

      return response.json();
    },
  });
}
